import { SectionLayout } from "./section-layout.tsx";
import { FC } from "react";

export const Root: FC= () => {
  return <SectionLayout />;
};

export default Root;
